import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { MailProvisioningRow } from "./type";

// Admin "E-posta Sağlama" — tenant domainlerinin Web/Mailcow/Brevo durumu + Brevo onay kapısı.
export const getMailProvisioning = createAction(
  "GET_MAIL_PROVISIONING",
  ({ payload }: SagaActionParams<MailProvisioningRow[]>) => ({
    payload,
    url: "/api/admin/MailProvisioning",
  })
);
export const brevoAddDomain = createAction(
  "BREVO_ADD_DOMAIN",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/MailProvisioning/brevo-add",
  })
);
export const brevoVerifyDomain = createAction(
  "BREVO_VERIFY_DOMAIN",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/MailProvisioning/brevo-verify",
  })
);

const mailProvisioningSaga = [
  takeLatest<any>(getMailProvisioning.toString(), (p: SagaGenericParams<MailProvisioningRow[]>) =>
    getSaga<MailProvisioningRow[]>(p)
  ),
  takeLatest<any>(brevoAddDomain.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(brevoVerifyDomain.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
];

export default mailProvisioningSaga;
